import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// .bns-choice radio: 18px, line-strong border, red once checked (accent).
export const Radio: ComponentMultiStyleConfig = {
  parts: ["label", "container", "control"],
  baseStyle: {
    control: {
      bg: "surface",
      borderWidth: "1px",
      borderColor: "lineStrong",
      _hover: {
        borderColor: "text",
      },
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "focus",
        outlineOffset: "2px",
      },
      _checked: {
        bg: "accent",
        borderColor: "accent",
        color: "onAccent",
        _hover: { bg: "accentHover", borderColor: "accentHover" },
        _disabled: { bg: "line", borderColor: "line", color: "textSubtle" },
      },
    },
    label: {
      color: "text",
    },
  },
  sizes: {
    md: {
      control: { w: "18px", h: "18px" },
      label: { fontSize: "sm" },
    },
    sm: {
      control: { w: "16px", h: "16px" },
      label: { fontSize: "xs" },
    },
  },
}
